import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FD0111",
  d: "M18.707 5.485H0v9.035h18.707z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FF0211",
  d: "m10.083 19.829 7.736-3.871c.546-.273.891-.832.891-1.44V5.482c0-.61-.345-1.168-.891-1.441L10.083.171a1.63 1.63 0 0 0-1.453 0L.895 4.042a1.61 1.61 0 0 0-.892 1.44v9.035c0 .61.346 1.168.892 1.441l7.735 3.871c.459.228.997.228 1.453 0"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#4DC9FF",
  d: "M15.807 9.787a4.194 4.194 0 1 0-.001-8.388 4.194 4.194 0 0 0 0 8.388"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "m2.576 13.255-.82-.411v-2.425c0-.712.402-1.418 1.226-1.328.771.083 1.368.769 1.553 1.218.288-.254.553-.306.934-.256.421.057 2.012.664 2.012 2.816v2.859l-.9-.451v-2.678c0-.785-.48-1.441-1.127-1.516-.268-.03-.498.183-.506.644-.007.46 0 2.723 0 2.723l-.824-.413V11.5c0-1.12-.721-1.473-1.04-1.508-.177-.02-.508.088-.508.659z"
}, null, -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_6]))
}
export default { render: render }